// extracted by mini-css-extract-plugin
export default {"aspectRatioSelector":"jG1nD___AspectRatioSelector-module__aspectRatioSelector"};